import React, { useState, useEffect } from 'react';
import {
    Button,
    Input,
    InputNumber,
    Switch,
    message,
    Card,
    Tag,
} from 'antd';
import { useDataState } from '../../hooks';
import api from '../../api';
import { adminErrorHandler } from '../../api/admin';
import { getNumberDisplayWithCommaNFloating } from '../../utils/string';
import './index.css';

function AdminPromotionPage() {
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [handicapMaxBet, setHandicapMaxBet] = useState();
    const [stepMaxPaid, setStepMaxPaid] = useState();
    const [bonusEnabled, setBonusEnabled] = useState(false);

    const maxBetData = useDataState();

    useEffect(() => {
        const promise = api.admin.getDefaultMaxBet();
        maxBetData.load(Promise.resolve(promise).then((value) => value));
    }, [loading]);

    const maxBetInfo = maxBetData?.data?.data;

    useEffect(() => {
        if (maxBetInfo) {
            setHandicapMaxBet(maxBetInfo.handicap_max_bet);
            setStepMaxPaid(maxBetInfo.step_max_paid);
            setBonusEnabled(maxBetInfo.new_user_bonus_enabled || false);
        }
    }, [maxBetInfo]);

    const onStartEdit = () => {
        setEditing(true);
    };

    const onCancelEdit = () => {
        if (maxBetInfo) {
            setHandicapMaxBet(maxBetInfo.handicap_max_bet);
            setStepMaxPaid(maxBetInfo.step_max_paid);
            setBonusEnabled(maxBetInfo.new_user_bonus_enabled || false);
        }
        setEditing(false);
    };

    const onSave = async () => {
        setLoading(true);
        try {
            const betPayload = {};
            if (handicapMaxBet !== undefined) betPayload.handicap_max_bet = handicapMaxBet;
            if (stepMaxPaid !== undefined) betPayload.step_max_paid = stepMaxPaid;
            await api.admin.setDefaultMaxBet(betPayload);
            await api.admin.setNewUserBonus({ new_user_bonus_enabled: bonusEnabled });
            message.success('ตั้งค่าสำเร็จ');
            setEditing(false);
        } catch (err) {
            adminErrorHandler(err);
            message.error('เกิดข้อผิดพลาด');
        }
        setLoading(false);
    };

    const settings = [
        {
            key: '1',
            label: 'ยอดเดิมพันบอลเต็งสูงสุด',
            value: handicapMaxBet,
            displayValue: getNumberDisplayWithCommaNFloating(maxBetInfo?.handicap_max_bet || 0),
            editRender: (
                <InputNumber
                    value={handicapMaxBet}
                    onChange={(val) => setHandicapMaxBet(val)}
                    style={{ width: 200 }}
                    min={0}
                />
            ),
        },
        {
            key: '2',
            label: 'ยอดจ่ายบอลสเต็ปสูงสุด',
            value: stepMaxPaid,
            displayValue: getNumberDisplayWithCommaNFloating(maxBetInfo?.step_max_paid || 0),
            editRender: (
                <InputNumber
                    value={stepMaxPaid}
                    onChange={(val) => setStepMaxPaid(val)}
                    style={{ width: 200 }}
                    min={0}
                />
            ),
        },
        {
            key: '3',
            label: 'โบนัสสมาชิกใหม่ (ทายผลคู่ปิด 1 ครั้ง)',
            isBoolean: true,
            value: bonusEnabled,
            displayValue: maxBetInfo?.new_user_bonus_enabled ? (
                <Tag color='green'>เปิด</Tag>
            ) : (
                <Tag color='red'>ปิด</Tag>
            ),
            editRender: (
                <Switch
                    checked={bonusEnabled}
                    onChange={(checked) => setBonusEnabled(checked)}
                />
            ),
        },
    ];

    return (
        <div>
            <div style={{ fontSize: '30px' }}>โปรโมชั่น / ตั้งค่าเดิมพัน</div>
            <div style={{ color: 'red', marginTop: '5px' }}>
                *ค่าที่แก้ไขจะมีผลกับ user ที่สร้างใหม่เท่านั้น
            </div>
            <Card style={{ marginTop: '20px' }}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '20px',
                    }}
                >
                    <div style={{ fontSize: '20px' }}>ตั้งค่าเดิมพันเริ่มต้น</div>
                    {!editing ? (
                        <Button
                            type='primary'
                            onClick={onStartEdit}
                            style={{ background: '#F7D249', color: 'black' }}
                        >
                            แก้ไข
                        </Button>
                    ) : (
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Button onClick={onCancelEdit}>ยกเลิก</Button>
                            <Button
                                type='primary'
                                onClick={onSave}
                                loading={loading}
                                style={{ background: '#F7D249', color: 'black' }}
                            >
                                บันทึก
                            </Button>
                        </div>
                    )}
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                            <th style={{ textAlign: 'left', padding: '12px 8px', color: '#00000073' }}>รายการ</th>
                            <th style={{ textAlign: 'left', padding: '12px 8px', color: '#00000073' }}>ค่า</th>
                        </tr>
                    </thead>
                    <tbody>
                        {settings.map((item) => (
                            <tr key={item.key} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                <td style={{ padding: '12px 8px' }}>{item.label}</td>
                                <td style={{ padding: '12px 8px' }}>
                                    {editing ? item.editRender : item.displayValue}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Card>
        </div>
    );
}

export default AdminPromotionPage;
